<template>
    <ui-container class="space-y-8 py-8">

        <!-- Header. -->
        <ui-header :title="item.name" :subtitle="`Serial: ${item.serial}`">
            <template #actions>
                <ui-button-new icon="fas fa-pencil" @click="edit()">Edit</ui-button-new>
                <ui-button-new icon="fas fa-trash" danger @click="openDeleteModal">Delete</ui-button-new>
            </template>
        </ui-header>

        <ui-tabs active="overview" :tabs="tabs" #default="{ isActive }">
            <!-- Overview. -->
            <ui-data-grid v-if="isActive('overview')">
                <ui-data-grid-item label="Description" :value="item.description"></ui-data-grid-item>
                <ui-data-grid-item label="Serial Number" :value="item.serial"></ui-data-grid-item>
                <ui-data-grid-item label="Assigned To" :value="(item.used_by ? item.used_by.label : '—')"></ui-data-grid-item>
                <ui-data-grid-item label="Created By" :value="item.created_by.name"></ui-data-grid-item>
                <ui-data-grid-item label="Created At" :value="item.created_at"></ui-data-grid-item>
                <ui-data-grid-item label="Updated At" :value="item.updated_at"></ui-data-grid-item>
            </ui-data-grid>

            <!-- Notes. -->
            <div v-else-if="isActive('notes')">
                <notes :get-url="item.notes_url" :post-url="item.notes_url"></notes>
            </div>
        </ui-tabs>

    </ui-container>
</template>

<script>
export default {
    props: {
        item: Object,
        edit: Function,
        removeItem: Function,
    },
    data () {
        return {
            tabs: [
                { value: 'overview', label: 'Overview' },
                { value: 'notes', label: 'Notes' },
            ],
        }
    },
    methods: {
        openDeleteModal () {
            const title = 'Are you sure you want to delete "' + this.item.name + '"?'
            const description = 'Deleting this device is irreversible. Are you sure you want to delete it?'
            eventBus.$emit('delete-modal-open', title, description, async () => {
                await this.item.delete()
                this.removeItem(this.item)

            });
        },
    },
}
</script>
